import { PureComponent } from 'react'
import ReactDOM from 'react-dom'

export class PrintWindow extends PureComponent {
  containerEl = document.createElement('div')
  containerHead = document.createElement('style')

  componentDidMount() {
    this.externalWindow = window.open('', 'Print', 'width=600,height=700')
    this.containerHead.innerHTML = '@page { size: auto;  margin: 20px; }'

    this.externalWindow.document.head.appendChild(this.containerHead)
    this.externalWindow.document.body.appendChild(this.containerEl)
    this.externalWindow.document.body.style.margin = 0

    this.externalWindow.focus()
    this.externalWindow.print()
  }

  componentWillUnmount() {
    this.externalWindow.document.close()
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.containerEl)
  }
}



// WEBPACK FOOTER //
// ./src/components/PrintWindow/PrintWindow.js